import { createApi } from "redux-future-middleware";
import { requestApi } from "core/api";
import * as types from "./types";

export const sendInvitation = createApi({
  name: types.SEND_INVITATION,
  request: ({ body }) =>
    requestApi({
      path: "/referral/invitation/",
      method: "POST",
      body
    })
});

export const sendInsiderInvitation = createApi({
  name: types.SEND_INSIDER_INVITATION,
  request: ({ body }) =>
    requestApi({
      path: "/referral/invitation/",
      method: "POST",
      body
    })
});

export const acceptInvitation = createApi({
  name: types.ACCEPT_INVITATION,
  request: ({ key }) =>
    requestApi({
      path: "/referral/accept-invitation/",
      method: "POST",
      body: { key: key }
    })
});

export const validateInsiderInvitation = createApi({
  name: types.VALIDATE_INSIDER_INVITATION,
  request: ({ id, token }) =>
    requestApi({
      path: `/referral/invitation-token-validation/${id}/${token}/`,
      method: "GET"
    })
});



// WEBPACK FOOTER //
// ./src/modules/referral/api.js